import React, { useEffect, useState } from 'react';
import './session-exceeded.m.css';
import { getPath, getTextContrast } from '../../../../utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { SuccessMessage } from '../../login/atoms/success-message';
import { getDarkModeStyle } from '../../login/util';
import {
  KICK_API,
  LOGOUT_API,
  SESSION_LIMIT_CANCEL_BUTTON,
  SESSION_LIMIT_ERROR,
  SESSION_LIMIT_LOG_IN_BUTTON,
  SESSION_LIMIT_MESSAGE,
  SESSION_LIMIT_SUCCESS
} from '../../../../constants';

const triggerLogout = async (sketchesHost, setRedirect) => {
  try {
    const url = getPath({ sketchesHost, relativePath: LOGOUT_API });
    await fetch(url);
    setRedirect(true);
  } catch (err) {
    return console.log('Error during logout: ', err);
  }
};

const terminateOtherSessions = async (sketchesHost, setMsgType, setRedirect) => {
  try {
    const url = getPath({ sketchesHost, relativePath: KICK_API });
    const response = await fetch(url, { method: 'POST' });
    if (response.status === 204) {
      setMsgType('success');
      setRedirect(true);
    } else {
      setMsgType('failure');
      triggerLogout(sketchesHost, setRedirect);
    }
  } catch (err) {
    setMsgType('failure');
    triggerLogout(sketchesHost, setRedirect);
    return console.log('Error during terminating other sessions: ', err);
  }
};

export const SessionExceeded = () => {
  const [redirect, setRedirect] = useState(false);
  const [msgType, setMsgType] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginButtonClicked, setLoginButtonClicked] = useState(false);
  const config = useSelector(state => get(state, ['qt', 'config'], {}));
  const { primaryColor = '#4860BC', darkPrimaryColor = '#4860BC' } = get(config, ['pagebuilder-config', 'general'], {});
  const enableDarkMode = useSelector(state => get(state, ['header', 'isDarkModeEnabled'], false));
  const buttonBgColor = enableDarkMode ? darkPrimaryColor : primaryColor;
  const textColor = getTextContrast(buttonBgColor) === 'dark' ? '#000' : '#fff';
  const sketchesHost = get(config, ['sketches-host'], '');
  const { continueButton, cancelButton, blockedSessionMessage, successMessage, errorMessage } = get(
    config,
    ['pagebuilder-config', 'sessionLimit'],
    {}
  );
  const mode = getDarkModeStyle();
  const redirectUrl = global?.localStorage?.getItem('sessionExceededRedirectUrl') || '/';

  useEffect(() => {
    setTimeout(() => {
      if (redirect) {
        global?.localStorage?.removeItem('sessionExceededRedirectUrl');
        window.location.href = redirectUrl;
      }
    }, 3000);
  }, [redirect]);

  function LogoutButton() {
    const logoutButtonTxt = cancelButton || SESSION_LIMIT_CANCEL_BUTTON
    async function clickHandler() {
      if(loading) return
      setLoading(true)
      await triggerLogout(sketchesHost, setRedirect);
    }
    const buttonStyle = loading ? `button logout-button loading` : `button logout-button`
    return <div styleName={buttonStyle} onClick={clickHandler} data-test-id="session-limit-cancel-button">
      {loading ? <Spinner /> : logoutButtonTxt}
    </div>
  }

  return (
    <div className={'loader-overlay-container'} styleName={'session-exeeded'}>
      <div styleName={`${mode} wrapper`}>
        <p styleName='message' data-test-id="session-limit-message">{blockedSessionMessage || SESSION_LIMIT_MESSAGE}</p>
        <div styleName='button-wrapper'>
          <div
            styleName={loginButtonClicked? 'button login-button loading': 'button login-button'}
            onClick={() => {
              if (!loginButtonClicked) {
                setLoginButtonClicked(true);
                terminateOtherSessions(sketchesHost, setMsgType, setRedirect);
              }
            }}
            style={{ color: textColor }}
            data-test-id="session-limit-kill-other-sessions-button"
          >
            {continueButton || SESSION_LIMIT_LOG_IN_BUTTON}
          </div>
          <LogoutButton />
        </div>
        {msgType === 'failure' && <div styleName='error-message' data-test-id="session-limit-error-message">{errorMessage || SESSION_LIMIT_ERROR}</div>}
      </div>
      <div styleName={`${mode} toast-msg`}>
        {msgType === 'success' && (
          <SuccessMessage
            message={successMessage || SESSION_LIMIT_SUCCESS}
            mode={mode}
            defaultRedirectUrl={redirectUrl}
            pageType={'session-exceeded'}
          />
        )}
      </div>
    </div>
  );
};


function Spinner() {
  return (
    <svg
      styleName="spinner"
      viewBox="0 0 24 24"
      role="img"
      aria-label="Loading"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        styleName="track"
      />
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        styleName="indicator"
      />
    </svg>
  );
}